import { combineReducers } from 'redux';
import { APIReducer } from 'store/apiReducer';
import {
    CONTEXT_DECLARATION_ARME_PERDUE_VOLEE_RECUPERER,
    CONTEXT_DECLARATION_ARME_PERDUE_VOLEE_VALIDER,
} from '../../../constants/apiUrls.constants';

const signalerArmePerdueVolee = combineReducers({
    reponse: APIReducer.bind(null, CONTEXT_DECLARATION_ARME_PERDUE_VOLEE_VALIDER),
    recuperer: APIReducer.bind(null, CONTEXT_DECLARATION_ARME_PERDUE_VOLEE_RECUPERER),
});

export default signalerArmePerdueVolee;
